/**
 * Query keys for the financial statements input page. Kept in their own module so the chat can
 * invalidate them after an agentic save without importing the page's hooks.
 */
export const FINANCIAL_STATEMENTS_QUERY_KEY = 'financial-statements';

/**
 * Query key for the FS-specific unintegrated-changes check. Distinct from
 * `HAS_UNINTEGRATED_CHANGES_QUERY_KEY` because the two backends look at different
 * source data (operational/disclosure points vs. financial statements) and we want
 * mutations to invalidate exactly the relevant one without coupling them.
 */
export const HAS_UNINTEGRATED_FINANCIAL_STATEMENT_CHANGES_QUERY_KEY = 'has-unintegrated-financial-statement-changes';
